import AppDispatcher from '../dispatcher/AppDispatcher';
import { ActionTypes } from '../constants/AppConstants';

const TrackingActions = {
    jpLayoutTabSelect (layout) {
        AppDispatcher.dispatch({
            layout,
            actionType: ActionTypes.JP_CHANGE_LAYOUT
        });
    },
    jpFareClassFilterClick (fareClass, value) {
        AppDispatcher.dispatch({
            fareClass,
            value,
            actionType: ActionTypes.JP_FARE_CLASS_FILTER_CLICK
        });
    },
    jpFareSelectionFilterClick (selection) {
        AppDispatcher.dispatch({
            selection,
            actionType: ActionTypes.JP_FARE_SELECTION_FILTER_CLICK
        });
    },
    jpTocSpecificFilterRendered () {
        AppDispatcher.dispatch({
            actionType: ActionTypes.JP_TOC_SPECIFIC_FILTER_RENDERED
        });
    },
    jpTocSpecificFilterClick (value) {
        AppDispatcher.dispatch({
            value,
            actionType: ActionTypes.JP_TOC_SPECIFIC_FILTER_CLICK
        });
    },
    jpAllFaresAccordionClick (value) {
        AppDispatcher.dispatch({
            value,
            actionType: ActionTypes.JP_ALL_FARES_ACCORDION_CLICK
        });
    },
    jpCheckoutWithSuggestedProducts () {
        AppDispatcher.dispatch({
            actionType: ActionTypes.JP_CHECKOUT_WITH_SUGGESTED_PRODUCTS
        });
    },
    jpChangedSearchType (searchType) {
        AppDispatcher.dispatch({
            searchType,
            actionType: ActionTypes.JP_CHANGE_SEARCH_TYPE
        });
    },
    genericModalOpen (type) {
        AppDispatcher.dispatch({
            type,
            actionType: ActionTypes.GENERIC_MODAL_OPEN
        });
    },
    returnTravelcardAdded (orderTrip) {
        AppDispatcher.dispatch({
            orderTrip,
            actionType: ActionTypes.RETURN_TRAVELCARD_CTA_CLICK
        });
    },
    deliveryMethod (order, eventType) {
        AppDispatcher.dispatch({
            order,
            eventType,
            actionType: ActionTypes.DELIVERY_METHOD
        });
    },
    paymentMethod (id, paymentMethod, eventType) {
        AppDispatcher.dispatch({
            id,
            paymentMethod,
            eventType,
            actionType: ActionTypes.PAYMENT_METHOD
        });
    },
    widgetStationSearch (search) {
        AppDispatcher.dispatch({
            search,
            actionType: ActionTypes.WIDGET_SEARCH_STATION_SELECT
        });
    },
    widgetStationSwitch () {
        AppDispatcher.dispatch({
            actionType: ActionTypes.WIDGET_SEARCH_STATION_SWITCH
        });
    },
    widgetDaySelect(data) {
        AppDispatcher.dispatch({
            data,
            actionType: ActionTypes.WIDGET_SEARCH_DAY_SELECT
        });
    },
    widgetSearchClick (type) {
        AppDispatcher.dispatch({
            type,
            actionType: ActionTypes.WIDGET_SEARCH_CLICK
        });
    },
    expandFares (type) {
        AppDispatcher.dispatch({
            type,
            actionType: ActionTypes.FARES_EXPAND
        });
    },
    plusBusSelect (type) {
        AppDispatcher.dispatch({
            type,
            actionType: ActionTypes.PLUS_BUS_SELECT
        });
    },
    externalLink (type) {
        AppDispatcher.dispatch({
            type,
            actionType: ActionTypes.EXTERNAL_LINK
        });
    },
    jobcenterPlusRailcardToggle (type) {
        AppDispatcher.dispatch({
            type,
            actionType: ActionTypes.RAILCARD_JOBCENTREPLUS_CHECKED
        });
    },

    showFlexiWarningModal (context) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SHOW_FLEXI_WARNING_MODAL,
            context
        });
    },
    flexiWarningModalAcknowledgementCheckboxChecked (context) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.FLEXI_WARNING_MODAL_ACKNOWLEDGEMENT_CHECKBOX_CHECKED,
            context
        });
    },
    flexiWarningModalAcknowledgementCheckboxUnchecked (context) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.FLEXI_WARNING_MODAL_ACKNOWLEDGEMENT_CHECKBOX_UNCHECKED,
            context
        });
    },
    flexiWarningModalClose (context) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.FLEXI_WARNING_MODAL_CLOSE,
            context
        });
    },
    flexiWarningModalContinue (context) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.FLEXI_WARNING_MODAL_CONTINUE,
            context
        });
    },
    flexiWarningModalMoreInfoClicked (context) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.FLEXI_WARNING_MODAL_MORE_INFO_CLICKED,
            context
        });
    },
    userOptedIn (from) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.USER_OPTED_IN,
            from
        });
    },
    userOptedOut () {
        AppDispatcher.dispatch({
            actionType: ActionTypes.USER_OPTED_OUT,
        });
    },
    selectNotificationPreference (method) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SELECT_NOTIFICATION_PREFERENCE,
            method
        });
    },
    selectRepaymentMethod (method) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SELECT_REPAYMENT_METHOD,
            method
        });
    },
    amendNotificationPreference () {
        AppDispatcher.dispatch({
            actionType: ActionTypes.AMEND_NOTIFICATION_PREFERENCE,
        });
    },
    amendRepaymentMethod () {
        AppDispatcher.dispatch({
            actionType: ActionTypes.AMEND_REPAYMENT_METHOD,
        });
    },
    amendAddress () {
        AppDispatcher.dispatch({
            actionType: ActionTypes.AMEND_ADDRESS,
        });
    },
    saveRegularJourneyAlertWithOCDRFavJourney () {
        AppDispatcher.dispatch({
            actionType: ActionTypes.SAVE_REGULAR_JOURNEY_WITH_OCDR_FAV_JOURNEY,
        });
    },
    webchatOpened () {
        AppDispatcher.dispatch({
            actionType: ActionTypes.WEBCHAT_OPENED,
        });
    },
    backFromPaymentPage (context) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.BACK_FROM_PAYMENT_PAGE,
            context
        })
    },
    addAnotherJourneyOnDeliveryPage (context) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.ADD_ANOTHER_JOURNEY_ON_DELIVERY_PAGE,
            context
        })
    },
    addAnotherJourneyOnPaymentPage (context) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.ADD_ANOTHER_JOURNEY_ON_PAYMENT_PAGE,
            context
        })
    },
    addAnotherJourneyOnBasketModal (context) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.ADD_ANOTHER_JOURNEY_ON_BASKET_MODAL,
            context
        })
    },
    deliveryScreenBackNavigationTicketRemoved (context) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.DELIVERY_SCREEN_BACK_NAVIGATION_TICKET_REMOVED,
            context
        })
    },
    deliveryScreenBackNavigationTicketKept (context) {
        AppDispatcher.dispatch({
            actionType: ActionTypes.DELIVERY_SCREEN_BACK_NAVIGATION_TICKET_KEPT,
            context
        })
    },
};

export default TrackingActions;



// WEBPACK FOOTER //
// ./src/actions/TrackingActions.js